
import {Fetch} from "../../utils/storage"
import Selector from 'vux/src/components/selector/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Checklist from 'vux/src/components/checklist/index.vue'
import XSwitch from 'vux/src/components/x-switch/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'

import {ParseTime} from "../../utils/time"
import {Api} from "../../utils/api"
import Pay from "../../utils/pay"
import Uploader from "vux-uploader-component";


export default {
name: 'Meeting-list',
components: {
Uploader,
XSwitch,
XInput,
Selector,
XButton,
Group,
Confirm,
Cell,
Checklist,
},
filters: {
/**
* @return {string}
*/
MeetingTimeFilter(val) {
let start = ParseTime(val.StartAt,'{y}-{m}-{d}')
let end = ParseTime(val.EndAt,'{y}-{m}-{d}')
return `${start} 至 ${end}`
}

},
data () {
return {
emailChangeText: '',
emailAddConfirm: false,
Meeting:{},
MeetingID: 0,
UserID:0,
CurrentStage:'SubMeeting',
PreState:false,
IsFirstOverAll: true,

ShowInvType:'Chosen',
InvoAdd:{},
InvoiceInfo:{},
InvoiceInfoList: [],
InvoiceInfoOptions:[],
ChosenInvoiceInfo: [],
DefaultInvoiceInfoIndex:0,
ShowInvoiceInfoPop: false,

RegAdd:{
Registration:{},
sexs: ['男', '女'],
nations: ['汉族', '蒙古族', '回族', '藏族', '维吾尔族', '苗族', '彝族', '壮族', '布依族', '朝鲜族', '满族', '侗族', '瑶族', '白族', '土家族', '哈尼族', '哈萨克族', '傣族', '黎族', '僳僳族', '佤族', '畲族', '高山族', '拉祜族', '水族', '东乡族', '纳西族', '景颇族', '柯尔克孜族', '土族', '达斡尔族', '仫佬族', '羌族', '布朗族', '撒拉族', '毛南族', '仡佬族', '锡伯族', '阿昌族', '普米族', '塔吉克族', '怒族', '乌孜别克族', '俄罗斯族', '鄂温克族', '德昂族', '保安族', '裕固族', '京族', '塔塔尔族', '独龙族', '鄂伦春族', '赫哲族', '门巴族', '珞巴族', '基诺族'],
provinces: ['北京市', '天津市', '河北省', '山西省', '内蒙古自治区', '辽宁省', '吉林省', '黑龙江省', '上海市', '江苏省', '浙江省', '安徽省', '福建省', '江西省', '山东省', '河南省', '湖北省', '湖南省', '广东省', '广西壮族自治', '海南省', '重庆市', '四川省', '贵州省', '云南省', '西藏自治区', '陕西省', '甘肃省', '青海省', '宁夏回族自治区', '新疆维吾尔自治区', '香港特别行政区', '澳门特别行政区', '台湾省'],
duties: ['部长','副部长','院长','副院长','局长', '副局长',  '主任', '副主任','书记','副书记','处长','副处长','科长','副科长', '科员', '主治医生', '医生', '学术研究员', '护士长', '护士', '其他'],
titles: ['副高及以上', '中级', '初级', '乡村医生', '无职称'],
committee_title: ['无任职', '顾问', '名誉主任委员', '主任委员', '副主任委员', '常务委员', '委员', '秘书长', '副秘书长', '秘书'],
},
ShowRegType: 'Chosen',
RegistrationList:[],
RegistrationOptions:[],
ChosenRegistration: [],
DefaultRegistrationIndex:0,
ShowRegistrationPop: false,
Registration: null,

CredAdd: {
CreditInfo:{},
sexs: ['男', '女'],
diploma: ['小学', '初中', '中专', '高中', '大专', '大学', '研究生', '博士', '博士后'],
provinces: ['北京市', '天津市', '河北省', '山西省', '内蒙古自治区', '辽宁省', '吉林省', '黑龙江省', '上海市', '江苏省', '浙江省', '安徽省', '福建省', '江西省', '山东省', '河南省', '湖北省', '湖南省', '广东省', '广西壮族自治', '海南省', '重庆市', '四川省', '贵州省', '云南省', '西藏自治区', '陕西省', '甘肃省', '青海省', '宁夏回族自治区', '新疆维吾尔自治区', '香港特别行政区', '澳门特别行政区', '台湾省'],
duties: ['部长','副部长','院长','副院长','局长', '副局长',  '主任', '副主任','书记','副书记','处长','副处长','科长','副科长', '科员', '主治医生', '医生', '学术研究员', '护士长', '护士', '其他'],
titles: ['副高及以上', '中级', '初级', '乡村医生', '无职称'],
committee_title: ['无任职', '顾问', '名誉主任委员', '主任委员', '副主任委员', '常务委员', '委员', '秘书长', '副秘书长', '秘书'],
},
ShowCredType: 'Chosen',
CreditInfoList:[],
CreditInfoOptions:[],
ChosenCreditInfo: [],
DefaultCreditInfoIndex:0,
CreditInfo: null,

SubMeetingList:[],
SubMeetingsOptions:[],
ChosenSubMeeting:[],
SubMeeting:null,

MeetingReceiptOrders: [],
MeetingReceiptOrder: {},
fileList: [],
remoteUrl: `http://api.c64ade55d3c0c44edace4f7fe6db1d8ba.cn-beijing.alicontainer.com/auxiliary-micro/user-end/image-upload?style=compress&category=meeting-receipt-image&copy=true&owner=`,
remoteCertiticateUrl: `http://api.c64ade55d3c0c44edace4f7fe6db1d8ba.cn-beijing.alicontainer.com/auxiliary-micro/user-end/image-upload?style=compress&category=meeting-certificate-image&copy=true&owner=`,
PayMethodList:[
{value: '微信支付',  key: 'wechat'},
{value: '刷卡',  key: 'card'},
{value: '转账',  key: 'transfer'},
{value: '现金',  key: 'cash'}
],
ChosenPayMethod:['wechat'],

hasCertificate: false,
needSubmitCertificate: false,
MeetingCertificates: [],
MeetingCertificate: {},
MeetingCertificateList: [],

RegistrationIDCardChangeText: '',
RegistrationIDCardAddConfirm: false,
IsIDCard: function (value) {
var reg =/(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}$)/;
console.log("test", reg.test(value))
if(!reg.test(value)){
return {
valid: false,
msg: '身份证格式错误'
}
} else {
return {
valid: true
}
}
},


}
},
watch: {
CurrentStage: function (newValue, oldValue) {
if (newValue !== oldValue && newValue === 'OverAll' && oldValue === 'ReceiptSubmit' && this.IsFirstOverAll) {
this.IsFirstOverAll = false
return
}
if (newValue !== oldValue && newValue === 'OverAll' && this.IsFirstOverAll) {
let _this = this
this.$vux.confirm.show({
theme: 'ios',
content: `<span style="font-size:20px">此会议类型为"培训班"，请填写回执单。右下按钮开始填写</span>`,
confirmText:"现在填写",
showCancelButton:false,
async onConfirm(){
_this.handleReceiptEdit(0)
}
})
}
}
},
async created () {
this.MeetingID = this.$route.params["meetingID"]
if (!this.MeetingID) this.$router.go(-1)
this.MeetingID = parseInt(this.MeetingID)
this.UserID = Fetch("ID")
this.remoteUrl = `${this.remoteUrl}${this.UserID}`
this.remoteCertiticateUrl = `${this.remoteCertiticateUrl}${this.UserID}`
await this.fetchMeetingDetail()
this.fetchRegistrationList()
this.fetchInvoiceInfoList()
this.fetchCreditInfoList()
},
methods: {
UpdateInfo(val, preval){
this.CurrentStage = val
this.PreState = preval
},
async fetchMeetingDetail() {
let res = await Api('GetMeetingList',{
Data:{
ID:this.MeetingID,
},
Preloads:[
{Column:'SubMeetings'},
{Column:'MeetingImages'},
{Column:'MeetingCertificates'},
{Column:'MeetingReceipts'},
{Column:'SubMeetings.Hotels'},
{Column:'SubMeetings.Hotels.HotelRooms'}
]
})
if (res.data.List && res.data.List.length === 1) {
this.Meeting = res.data.List[0]
let start = new Date(new Date(this.Meeting.StartAt).getTime() -1000*60*60*24)
let end = new Date(new Date(this.Meeting.EndAt).getTime() + 1000*60*60*24)
this.Meeting.checkInAt = `${start.getFullYear()}-${(start.getMonth()+1) > 9 ? start.getMonth()+1 : '0' + (start.getMonth()+1)}-${start.getDate() > 9 ? start.getDate() : '0' + start.getDate()}`
this.Meeting.checkOutAt = `${end.getFullYear()}-${(end.getMonth()+1) > 9 ? end.getMonth()+1 : '0' + (end.getMonth()+1)}-${end.getDate() > 9 ? end.getDate() : '0' + end.getDate()}`
this.SubMeetingsOptions = this.Meeting.SubMeetings.map((value,index) =>{
return {
key: index+1,
value: value.Tittle,
inlineDesc: `费用：${(value.Fee ? (value.Fee + '元') : '免费')}`
}
})

this.SubMeetingList = this.Meeting.SubMeetings

this.MeetingReceiptOrders = this.Meeting.MeetingReceipts.map(item => {
let mr = Object.assign({}, item)
mr.FieldsData = JSON.parse(mr.Fields)
return mr
})


this.hasCertificate = this.Meeting.MeetingCertificates && this.Meeting.MeetingCertificates.length > 0
if (this.hasCertificate) {
let certificateNeedSubmitCount = 0
this.MeetingCertificates = this.Meeting.MeetingCertificates.map(item => {
let mc = Object.assign({}, item)
mc.FieldsData = JSON.parse(mc.Fields)
if (mc.FieldsData.length > 0) this.needSubmitCertificate = true
return mc
})
}
} else {
this.$vux.toast.show({
text:'获取会议信息出错',
type:'cancel',
})
this.$router.go(-1)
}
},
async fetchRegistrationList() {
let res = await Api('GetRegistrationList',{
Data:{
UserID:this.UserID,
},
Limit:999,
})
this.RegistrationList = res.data.List || []
this.RegistrationOptions = this.RegistrationList.map((value,index) =>{
if(value.Default) {
this.DefaultRegistrationIndex = index+1
this.ChosenRegistration = [index+1]
}
let inlindDesc = `${value.Company}`
if (this.hasCertificate) {
inlindDesc = `${inlindDesc}\n(身份证: ${value.IDCard || '暂无'})`
}
return {
key: index+1,
value: `${value.Name}\n(${value.PhoneNumber})`,
inlineDesc: inlindDesc
}
})
this.ShowRegType = this.RegistrationList.length > 0 ? 'Chosen' : 'Add'
},
async fetchCreditInfoList() {
let res = await Api('GetCreditInfoList',{
Data:{
UserID:this.UserID,
},
Limit:999,
})
this.CreditInfoList = res.data.List || []
this.CreditInfoOptions = this.CreditInfoList.map((value,index) =>{
if(value.Default) {
this.DefaultCreditInfoIndex = index+1
this.ChosenCreditInfo = [index+1]
}
return {
key: index+1,
value: `${value.Name}-${value.PhoneNumber}`,
inlineDesc: `${value.Company}-${value.IDCard}`
}
})
this.ShowCredType = this.CreditInfoList.length > 0 ? 'Chosen' : 'Add'
},
async fetchInvoiceInfoList() {
let res = await Api('GetInvoiceInfoList',{
Data:{
UserID:this.UserID,
},
Limit:999,
})
this.InvoiceInfoList = res.data.List || []
this.InvoiceInfoOptions = this.InvoiceInfoList.map((value,index) =>{
if(value.Default) {
this.DefaultInvoiceInfoIndex = index+1
this.ChosenInvoiceInfo = [index+1]
}
return {
key: index+1,
value: value.Title,
inlineDesc: `${value.TaxNumber}\n 接收邮箱: ${value.Email || '暂无'}`
}
})
this.ShowInvType = this.InvoiceInfoList.length > 0 ? 'Chosen' : 'Add'
},
handleRegistrationChosenSubmit() {
if(this.ChosenRegistration.length < 1) {
this.$vux.confirm.show({
theme: 'ios',
content: '<span style="font-size:20px">您还没选择参会人！</span>',
showCancelButton:false,
})
}
if (this.hasCertificate && !this.Registration.IDCard) {
this.RegistrationIDCardAddConfirm = true
return
}
if (this.PreState){
this.CurrentStage = this.PreState
this.PreState = ''
} else if (this.hasCertificate && this.needSubmitCertificate) {
this.CurrentStage = 'MeetingCertificateSubmit'
} else if (this.SubMeeting && !this.SubMeeting.Fee){
if (this.SubMeeting && this.SubMeeting.HasCredit === 1) {
this.CurrentStage = 'CreditInfoPre'
} else {
this.CurrentStage = 'OverAll'
}
} else {
this.CurrentStage = 'Invoice'
}
},
async handleRegistrationAddSubmit() {
let _this = this
if (!_this.RegAdd.Registration.Name ||
!_this.RegAdd.Registration.Province ||
!_this.RegAdd.Registration.PhoneNumber ||
!_this.RegAdd.Registration.Sex ||
!_this.RegAdd.Registration.Nation ||
!_this.RegAdd.Registration.Company ||
!_this.RegAdd.Registration.Duty ||
!_this.RegAdd.Registration.Title) {
_this.$vux.toast.show({
text: '必选参数不能为空',
type: 'text',
width:'3rem'
})
return
}
_this.RegAdd.Registration.Sex = _this.RegAdd.Registration.Sex === '男' ? 1 : 2
_this.RegAdd.Registration.IsBasic = _this.RegAdd.Registration.basic ?1 : -1
_this.RegAdd.Registration.UserID = Fetch('ID')
_this.RegAdd.Registration.Default = true
_this.$vux.confirm.show({
theme: 'ios',
content: `<span style="font-size:20px">确认参会人信息无误，并创建？</span>`,
confirmText:"确认",
cancelText:"取消",
async onConfirm(){
try {
await Api('CreateRegistration',_this.RegAdd.Registration)
_this.$vux.toast.show({
text: '创建成功',
type: 'text',
width:'3rem'
})
_this.RegAdd.Registration = {}
await _this.fetchRegistrationList()
}catch(err) {
_this.$vux.toast.show({
text: '添加参会人失败',
type: 'cancel',
width:'3rem'
})
}
}
})
},
async UpdateRegistrationIDCard() {
let _this = this
if (!_this.$refs.RegistrationIDCardAddInput.valid) {
_this.$vux.toast.show({
text: '身份证格式不正确，请重新填写！',
type: 'text',
width:'3rem'
})
return
}
if (!_this.RegistrationIDCardChangeText) {
_this.$vux.toast.show({
text: '身份证不可为空，请重新填写！',
type: 'text',
width:'3rem'
})
return
}
let registration_id = _this.Registration.ID
await Api('UpdateRegistration',{ID: registration_id, IDCard: _this.RegistrationIDCardChangeText})
await _this.fetchRegistrationList()
_this.Registration =  _this.RegistrationList.filter(item => item.ID == registration_id)[0]
_this.RegistrationIDCardChangeText = ''
_this.RegistrationIDCardAddConfirm = false

},
CancelRegistrationIDCard() {
this.RegistrationIDCardChangeText = ''
},
handleRegistrationChange(val) {
let registration = this.RegistrationList[val-1]
if (!registration) {
return
}
if (this.hasCertificate && !registration.IDCard) {
this.RegistrationIDCardAddConfirm = true
}
this.Registration = registration
},
handleCreditInfoChosenSubmit() {
if(this.ChosenCreditInfo.length < 1) {
this.$vux.confirm.show({
theme: 'ios',
content: '<span style="font-size:20px">您还没选择学分信息！</span>',
showCancelButton:false,
})
return
}
if (this.PreState){
this.CurrentStage = this.PreState
this.PreState = ''
}else if (this.SubMeeting && !this.SubMeeting.Fee){
this.CurrentStage = 'OverAll'
}else {
this.CurrentStage = 'OrderPay'
if (this.SubMeeting.IsLive > 0) {
this.PayMethodList = [
{value: '微信支付',  key: 'wechat'},
{value: '转账',  key: 'transfer'},
]
} else {
this.PayMethodList = [
{value: '微信支付',  key: 'wechat'},
{value: '刷卡',  key: 'card'},
{value: '转账',  key: 'transfer'},
{value: '现金',  key: 'cash'}
]
}
}

},
handleCreditInfoChange(val) {
this.CreditInfo = this.CreditInfoList[val-1]
},
handleCreditInfoSkip(){
this.CreditInfo = {}
if (this.PreState) {
this.CurrentStage = this.PreState
this.PreState = ''
} else if (this.SubMeeting && !this.SubMeeting.Fee){
this.CurrentStage = 'OverAll'
} else {
this.CurrentStage = 'OrderPay'
if (this.SubMeeting.IsLive > 0) {
this.PayMethodList = [
{value: '微信支付',  key: 'wechat'},
{value: '转账',  key: 'transfer'},
]
} else {
this.PayMethodList = [
{value: '微信支付',  key: 'wechat'},
{value: '刷卡',  key: 'card'},
{value: '转账',  key: 'transfer'},
{value: '现金',  key: 'cash'}
]
}
}
},
async handleCreditInfoAddSubmit() {
let _this = this
if (!_this.CredAdd.CreditInfo.Name ||
!_this.CredAdd.CreditInfo.PhoneNumber ||
!_this.CredAdd.CreditInfo.IDCard ||
!_this.CredAdd.CreditInfo.EduBackground ||
!_this.CredAdd.CreditInfo.ContactAddress ||
!_this.CredAdd.CreditInfo.Email ||
!_this.CredAdd.CreditInfo.ZipCode ||
!_this.CredAdd.CreditInfo.Sex ||
!_this.CredAdd.CreditInfo.Province ||
!_this.CredAdd.CreditInfo.Company ||
!_this.CredAdd.CreditInfo.Department ||
!_this.CredAdd.CreditInfo.Duty ||
!_this.CredAdd.CreditInfo.Title) {
_this.$vux.toast.show({
text: '必选参数不能为空',
type: 'text',
width:'3rem'
})
return
}
_this.CredAdd.CreditInfo.Sex = _this.CredAdd.CreditInfo.Sex === '男' ? 1 : 2
_this.CredAdd.CreditInfo.UserID = Fetch('ID')
_this.CredAdd.CreditInfo.Default = true
this.$vux.confirm.show({
theme: 'ios',
content: `<span style="font-size:20px">确认学分信息无误，并创建？</span>`,
confirmText:"确认",
cancelText:"取消",
async onConfirm(){
try {
await Api('CreateCreditInfo',_this.CredAdd.CreditInfo)
_this.$vux.toast.show({
text: '创建成功',
type: 'text',
width:'3rem'
})
_this.CredAdd.CreditInfo = {}
await _this.fetchCreditInfoList()
}catch(err) {
_this.$vux.toast.show({
text: '添加学分信息失败',
type: 'cancel',
width:'3rem'
})
}
}
})
},
handleCreditInfoBack() {
if (this.SubMeeting && !this.SubMeeting.Fee){
this.CurrentStage = 'Registration'
} else {
this.CurrentStage='Invoice'
}
},
handleInvoiceInfoChosenSubmit() {
if (this.ChosenInvoiceInfo.length < 1) {
this.$vux.confirm.show({
theme: 'ios',
content: '<span style="font-size:20px">您还没选择发票抬头！</span>',
showCancelButton:false,
})
return
}

if (!this.InvoiceInfo.Email) {
this.emailAddConfirm = true
return
}

if (this.PreState){
this.CurrentStage = this.PreState
this.PreState = ''
}else {
if (this.SubMeeting && this.SubMeeting.HasCredit === 1) {
this.CurrentStage = 'CreditInfoPre'
} else {
this.CurrentStage = 'OrderPay'
if (this.SubMeeting.IsLive > 0) {
this.PayMethodList = [
{value: '微信支付',  key: 'wechat'},
{value: '转账',  key: 'transfer'},
]
} else {
this.PayMethodList = [
{value: '微信支付',  key: 'wechat'},
{value: '刷卡',  key: 'card'},
{value: '转账',  key: 'transfer'},
{value: '现金',  key: 'cash'}
]
}
}
}


},
async handleInvoiceInfoAddSubmit(){
let _this = this
if (
!_this.InvoAdd.TaxNumber ||
_this.InvoAdd.TaxNumber.length < 15) {
_this.$vux.toast.show({
text: '发票税号不可为空，且不得少于15位！',
type: 'text',
width:'3rem'
})
return
}
if (
!_this.InvoAdd.Title) {
_this.$vux.toast.show({
text: '发票税号不可为空，且不得少于15位！',
type: 'text',
width:'3rem'
})
return
}
if (!this.$refs.emailInput.valid) {
_this.$vux.toast.show({
text: '邮箱格式不正确！',
type: 'text',
width:'3rem'
})
return
}
_this.InvoAdd.UserID = Fetch('ID')
_this.InvoAdd.Default = true

this.$vux.confirm.show({
theme: 'ios',
content: `<span style="font-size:20px">确认发票信息信息无误，并创建？</span>`,
confirmText:"确认",
cancelText:"取消",
async onConfirm(){
try {
await Api('CreateInvoiceInfo',_this.InvoAdd)
_this.$vux.toast.show({
text: '创建成功',
type: 'text',
width:'3rem'
})
_this.InvoAdd = {}
await _this.fetchInvoiceInfoList()
}catch(err) {
_this.$vux.toast.show({
text: '添加发票信息失败',
type: 'cancel',
width:'3rem'
})
}
}
})
},
async UpdateInvoice() {
let _this = this
if (!_this.$refs.emailAddInput.valid) {
_this.$vux.toast.show({
text: '邮箱格式不正确，请重新填写！',
type: 'text',
width:'3rem'
})
return
}
if (!_this.emailChangeText) {
_this.$vux.toast.show({
text: '邮箱不可为空，请重新填写！',
type: 'text',
width:'3rem'
})
return
}
let invoice_id = _this.InvoiceInfo.ID

await Api('UpdateInvoiceInfo',{ID: invoice_id, Email: _this.emailChangeText})
await _this.fetchInvoiceInfoList()
_this.InvoiceInfo =  _this.InvoiceInfoList.filter(item => item.ID == invoice_id)[0]
_this.emailChangeText = ''
_this.emailAddConfirm = false

},
CancelInvoice() {
this.emailChangeText = ''
},
handleInvoiceInfoChange(val) {
let invoice = this.InvoiceInfoList[val-1]
if (!invoice) {
return
}
if (!invoice.Email) {
this.emailAddConfirm = true
}
this.InvoiceInfo = invoice
},
handleSubMeetingChange(val) {
this.SubMeeting = this.SubMeetingList[val-1]
},
handleSubMeetingChosenSubmit() {
if(!this.SubMeeting) {
this.$vux.confirm.show({
theme: 'ios',
content: '<span style="font-size:20px">您还没选择分会场！</span>',
showCancelButton:false,
})
return
}
if (this.PreState){
this.CurrentStage = this.PreState
this.PreState = ''
}else {
this.CurrentStage = 'Registration'
}
},
handleReceiptEdit(index) {
this.CurrentStage = "ReceiptSubmit"
this.MeetingReceiptOrder = this.MeetingReceiptOrders[index]
},
handleMeetingReceiptCancel() {
this.MeetingReceiptOrder._is_finished = false

this.MeetingReceiptOrder.FieldsData.forEach(item => {
delete item.Value
})
this.CurrentStage = "OverAll"
},
handleMeetingReceiptSubmit() {
for (let i = 0; i < this.MeetingReceiptOrder.FieldsData.length; i++) {
let item = this.MeetingReceiptOrder.FieldsData[i]
if (item.V === 'img') {
if (!item.fileList) {
this.$vux.toast.show({
text: `请完整填写『${item.N}』的相关信息！`,
type: 'text',
width:'3rem'
})
return
}

item.Value = item.fileList.map(file => {
return file.imgUrl
})
}
if (!item.Value) {
this.$vux.toast.show({
text: `请完整填写『${item.N}』的相关信息！`,
type: 'text',
width:'3rem'
})
return
}
}
this.MeetingReceiptOrder._is_finished = true


let currentIndex = -1
for (let i = 0; i < this.MeetingReceiptOrders.length; i++) {
if (this.MeetingReceiptOrders[i].ID === this.MeetingReceiptOrder.ID) {
currentIndex = i
break
}
}
let nextIndex = -1
for (let i = currentIndex + 1; i < this.MeetingReceiptOrders.length; i++) {
if (!this.MeetingReceiptOrders[i]._is_finished) {
nextIndex = i
break
}
}
if (nextIndex > 0 && this.IsFirstOverAll) {
this.handleReceiptEdit(nextIndex)
return
}
this.CurrentStage = "OverAll"
this.IsFirstOverAll = false
},
handleImageChange() {
},
handleImageCancel() {
},
handleImageSuccess(result, fileItem) {
fileItem.imgUrl = result.data[0]
},
handleImageError() {
this.$vux.toast.show({
text: '图片上传失败，请联系管理员',
type: 'cancel'
})
},
handleImageDelete(cb) {
for (let i = 0; i < this.MeetingReceiptOrder.FieldsData.length; i++) {
let field = this.MeetingReceiptOrder.FieldsData[i]
if (field.V !== 'img') {
continue
}
let delIndex = -1
field.fileList.forEach((item, index) => {
if (item.imgUrl === cb.imgUrl) {
delIndex = index
}
})
field.fileList.splice(delIndex, 1)
}

},
handleMeetingCertificateImageDelete(cb) {
for (let j = 0; j < this.MeetingCertificates.length; j++) {
let meetingCertificate = this.MeetingCertificates[j]
for (let i = 0; i < meetingCertificate.FieldsData.length; i++) {
let field = meetingCertificate.FieldsData[i]
if (field.V !== 'img') {
continue
}
if (!field.fileList) {
continue
}
let delIndex = -1

field.fileList.forEach((item, index) => {
if (item.imgUrl === cb.imgUrl) {
delIndex = index
}
})
if (delIndex > -1) {
field.fileList.splice(delIndex, 1)
}


}
}
},
async handleMeetingCertificateSubmit () {
for (let j = 0; j < this.MeetingCertificates.length; j++) {
let meetingCertificate = this.MeetingCertificates[j]
for (let i = 0; i < meetingCertificate.FieldsData.length; i++) {
let item = meetingCertificate.FieldsData[i]
if (item.V === 'img') {
if (!item.fileList) {
this.$vux.toast.show({
text: `请完整填写『${item.N}』的相关信息！`,
type: 'text',
width:'3rem'
})
return
}
item.Value = item.fileList.map(file => {
return file.imgUrl
})
}
if (!item.Value) {
this.$vux.toast.show({
text: `请完整填写『${item.N}』的相关信息！`,
type: 'text',
width:'3rem'
})
return
}
}

}
if (this.PreState){
this.CurrentStage = this.PreState
this.PreState = ''
} else if (this.SubMeeting && !this.SubMeeting.Fee){
if (this.SubMeeting && this.SubMeeting.HasCredit === 1) {
this.CurrentStage = 'CreditInfoPre'
} else {
this.CurrentStage = 'OverAll'
}
} else {
this.CurrentStage = 'Invoice'
}
},
async handleOverAllSubmit() {
if (!this.Registration || !this.Registration.ID) {
this.$vux.confirm.show({
theme: 'ios',
content: '<span style="font-size:20px">请选择您的参会人！</span>',
showCancelButton:false,
})
return
}
if (this.hasCertificate && !this.Registration.IDCard) {
this.$vux.confirm.show({
theme: 'ios',
content: '<span style="font-size:20px">此会议包含证书，请填写参会人身份证号！</span>',
showCancelButton:false,
})
return
}
if ((!this.InvoiceInfo || !this.InvoiceInfo.ID) && this.SubMeeting && this.SubMeeting.Fee) {
this.$vux.confirm.show({
theme: 'ios',
content: '<span style="font-size:20px">请选择开票对应的发票信息！</span>',
showCancelButton:false,
})
return
}
if ((!this.InvoiceInfo || !this.InvoiceInfo.Email) && this.SubMeeting && this.SubMeeting.Fee) {
this.emailAddConfirm = true
return
}
if (!this.SubMeeting || !this.SubMeeting.ID) {
this.$vux.confirm.show({
theme: 'ios',
content: '<span style="font-size:20px">请选择要报名参加的会场！</span>',
showCancelButton:false,
})
return
}
if (this.ChosenPayMethod.length < 1) {
this.$vux.confirm.show({
theme: 'ios',
content: '<span style="font-size:20px">请选择您的支付方式</span>',
showCancelButton:false,
})
return
}
let _this = this
for (let i = 0; i < this.MeetingReceiptOrders.length; i++) {
let item = this.MeetingReceiptOrders[i]
if (!item._is_finished && item.IsRequired) {

_this.$vux.confirm.show({
theme: 'ios',
content: `<span style="font-size:20px">"${item.Name}"为必填回执单，请填写</span>`,
confirmText:"现在填写",
cancelText:"稍后填写",
async onConfirm(){
_this.handleReceiptEdit(i)
}
})
return
}
}
let OrderMeetingReceipts = _this.MeetingReceiptOrders.map(item => {
item.FieldsData.forEach(field => {
if (field.V === 'img') {
delete field.fileList
}
})
return  {
FieldsData: JSON.stringify(item.FieldsData),
MeetingReceiptID: item.ID,
IsFeedback: item.IsFeedback ? 1: -1,
Name: item.Name,
UserID: _this.UserID,

}
})

for (let j = 0; j < _this.MeetingCertificates.length; j++) {
let meetingCertificate = _this.MeetingCertificates[j]
for (let i = 0; i < meetingCertificate.FieldsData.length; i++) {
let item = meetingCertificate.FieldsData[i]
if (item.V === 'img') {
if (!item.fileList) {
_this.$vux.confirm.show({
theme: 'ios',
content: `<span style="font-size:20px">证书所需信息未完善,请填写</span>`,
confirmText:"现在填写",
cancelText:"稍后填写",
async onConfirm(){
_this.CurrentStage = "MeetingCertificateSubmit"
}
})
return
}
item.Value = item.fileList.map(file => {
return file.imgUrl
})
}
if (!item.Value) {
_this.$vux.confirm.show({
theme: 'ios',
content: `<span style="font-size:20px">证书所需信息未完善,请填写</span>`,
confirmText:"现在填写",
cancelText:"稍后填写",
async onConfirm(){
_this.CurrentStage = "MeetingCertificateSubmit"
}
})
return
}
}

}
let OrderMeetingCertificates = _this.MeetingCertificates.map(item => {
let fieldsData = item.FieldsData.map(field => {
let _field = Object.assign({}, field)
if (_field.V === 'img') {
delete _field.fileList
}
return _field
})
return  {
FieldsData: JSON.stringify(fieldsData),
MeetingCertificateID: item.ID,
MeetingID: item.MeetingID,
IDCard: _this.Registration.IDCard,
Name: item.Name,
UserID: _this.UserID,
CertificateCoverImage: _this.Meeting.HeadImg,
RegistryName: _this.Registration.Name

}
})

_this.$vux.confirm.show({
theme: 'ios',
content: `<span style="font-size:20px">确认发票信息、参会人、分会场、酒店信息填写无误，并报名</span>`,
confirmText:"确认报名",
cancelText:"暂不报名",

async onConfirm(){
let req = {
UserID: _this.UserID,
SubMeetingID: _this.SubMeeting.ID,
MeetingID: _this.MeetingID,
IsLive: _this.SubMeeting.IsLive,
PhoneNumber:_this.Registration.PhoneNumber,
IDCard:_this.Registration.IDCard,
PayType: _this.ChosenPayMethod[0],
MeetingType: "training",
OrderMeetingReceipts: OrderMeetingReceipts,
OrderMeetingCertificates: OrderMeetingCertificates,
OrderInfo: {
MeetingHeadImg: _this.Meeting.HeadImg,
MeetingTitle: _this.Meeting.Tittle,
JoinAddress: _this.SubMeeting.Address,
JoinTime: `${_this.Meeting.StartAt}----${_this.Meeting.EndAt}`,
SubMeetingName: _this.SubMeeting.Tittle,
UserName: Fetch('NickName'),
RegistryName: _this.Registration.Name,
RegistryContact: _this.Registration.PhoneNumber,
RegistryIDCard: _this.Registration.IDCard,
RegistryCompany: _this.Registration.Company,
RegistryDuty: _this.Registration.Duty,
RegistryCommitteeTitle: _this.Registration.CommitteeTitle,
RegistryTitle: _this.Registration.Title,
RegistryProvince: _this.Registration.Province,
RegistryNation: _this.Registration.Nation,
RegistrySex: _this.Registration.Sex === 1 ? '男' : '女',
HasFood: _this.SubMeeting.HasFood,
HasMaterial: _this.SubMeeting.HasFood,
}
}
if (_this.SubMeeting && !_this.SubMeeting.Fee) {
req.PayType = 'card'
}

if (_this.SubMeeting.Fee) {
req.OrderInfo.InvoiceTitle = _this.InvoiceInfo.Title
req.OrderInfo.InvoiceNum = _this.InvoiceInfo.TaxNumber
req.OrderInfo.Email = _this.InvoiceInfo.Email
}
if (_this.CreditInfo && _this.CreditInfo.IDCard) {
req.IsCredit = 1
req.CreditInfo = {
Name : _this.CreditInfo.Name,
Sex : _this.CreditInfo.Sex,
IDCard : _this.CreditInfo.IDCard,
Company : _this.CreditInfo.Company,
Department : _this.CreditInfo.Department,
Duty : _this.CreditInfo.Duty,
CommitteeTitle : _this.CreditInfo.CommitteeTitle,
Title : _this.CreditInfo.Title,
EduBackground : _this.CreditInfo.EduBackground,
PhoneNumber : _this.CreditInfo.PhoneNumber,
Province : _this.CreditInfo.Province,
ContactAddress : _this.CreditInfo.ContactAddress,
ZipCode : _this.CreditInfo.ZipCode,
Email : _this.CreditInfo.Email,
Note : _this.CreditInfo.Note,
UserID : _this.UserID,
MeetingID : _this.Meeting.ID,
SubMeetingID : _this.SubMeeting.ID,
}
}

try {
_this.$vux.loading.show({
text: '订单正在创建'
})
let res = await Api('CreateOrder',req)
_this.$vux.loading.hide()
if (!res.data.IDs) {
_this.$vux.toast.show({
text: '创建订单失败',
type: 'cancel'
})
} else {
if (req.PayType === 'wechat') {
_this.handleWechatPay(res.data.IDs[0])
} else {
if (_this.SubMeeting.Hotels && _this.SubMeeting.Hotels.length > 0) {

_this.$vux.confirm.show({
theme: 'ios',
content: `
<p style="margin-bottom:10px;font-size:24px;font-weight: bold">会议报名成功</p>
<p style="text-align:left;font-size:18px;line-height:26px">温馨提示您：</p>
<p style="text-align:left;margin-top:8px;font-size:18px;line-height:26px">如需入住会议酒店，请点击酒店预订！</p>`,
confirmText:"预订酒店",
cancelText:"酒店自理",
onConfirm(){

_this.$router.push(`/order/detail/hotel/new/${res.data.IDs[0]}`)
},
onCancel() {

_this.$router.replace(`/order/detail/${res.data.IDs[0]}`)
}
})
} else {
_this.$vux.toast.show({
text: '会议报名成功！',
type: 'text',
width:'3rem'
})
_this.$router.replace(`/order/detail/${res.data.IDs[0]}`)
}
}
}
} catch(err) {
_this.$vux.loading.hide()
if(err.message) {
_this.$vux.toast.show({
text: err.message,
type: 'cancel'
})
}
}
}
})

},
async handleWechatPay(OrderID) {
try{
let _this = this
let res = await Api('GetMeetingPreOrder', {
OrderID: OrderID
})

Pay.invoke(
res.data,
function (){
if (_this.SubMeeting.Hotels && _this.SubMeeting.Hotels.length > 0) {
_this.$vux.confirm.show({
theme: 'ios',
content: `
<p style="margin-bottom:10px;font-size:24px;font-weight: bold">会议支付成功</p>
<p style="text-align:left;font-size:20px;line-height:30px">我们温馨提示您，如需酒店预订，请点击下方右侧，酒店预订</p>
`,
confirmText:"预订酒店",
cancelText:"酒店自理",
onConfirm(){

_this.$router.push(`/order/detail/hotel/new/${OrderID}`)
},
onCancel() {

_this.$router.replace(`/order/detail/${OrderID}`)
}
})
} else {
_this.$vux.toast.show({
text: '会议报名并缴费成功！',
type: 'text',
width:'3rem'
})
_this.$router.replace(`/order/detail/${OrderID}`)
}

},
function (){
if (_this.SubMeeting.Hotels && _this.SubMeeting.Hotels.length > 0) {
_this.$vux.confirm.show({
theme: 'ios',
content: `
<p style="margin-bottom:10px;font-size:24px;font-weight: bold">微信支付取消</p>
<p style="font-size:20px;line-height:30px">报名申请已经提交，但费用支付失败，后续可在"个人中心"-"待支付会议"中继续支付；</p>
`,
confirmText:"预订酒店",
cancelText:"酒店自理",
onConfirm(){

_this.$router.push(`/order/detail/hotel/new/${OrderID}`)
},
onCancel() {

_this.$router.replace(`/order/detail/${OrderID}`)
}
})
} else {
_this.$vux.confirm.show({
theme: 'ios',
content: `
<p style="margin-bottom:10px;font-size:24px;font-weight: bold">微信支付失败</p>
<span style="font-size:20px">报名申请已经提交，但费用支付失败。点击下方左侧进行"重新支付",或点击右侧"查看详情"</span>
`,
confirmText:"查看详情",
cancelText:"重新支付",
onCancel(){

_this.handleWechatPay(OrderID)
},
onConfirm() {

_this.$router.replace(`/order/detail/${OrderID}`)
}
})
}
}
)
}catch(err){
this.$vux.confirm.show({
theme: 'ios',
content: '<span style="font-size:20px">获取支付请求失败</span>',
showCancelButton:false,
})

}
},

},
}
